import React from 'react';
import NoAvatar from '../../assets/images/avatar.svg';
import { Icon } from 'components';
import {
  getSalonBadge,
  SALON_BADGE_LABEL,
  type SalonBadgeSource,
} from 'components/Avatar/salonBadge';

type AvatarChatGroupItem = {
  url?: string;
  disabled?: boolean;
} & SalonBadgeSource;

type Props = {
  size?: `w-${string}` | `h-${string}`;
  avatars: AvatarChatGroupItem[];
  border?: string;
  isPinned?: boolean;
};

const MAX_IMAGES = 3;

const positions: { [x: number]: string[] } = {
  1: [''],
  2: ['absolute w-[62%]', 'absolute w-[62%] bottom-0 right-0'],
  3: [
    'absolute w-[58%] right-0 top-1/3 -translate-y-1/3',
    'absolute w-[58%]',
    'absolute w-[58%] bottom-0 left-1/3 -translate-x-1/3',
  ],
};

function AvatarChatGroup({
  size = `w-full`,
  avatars,
  border = '',
  isPinned = false,
}: Props) {
  return (
    <div className={`relative aspect-square ${size}`}>
      {!!avatars.length &&
        (positions[avatars.length] || positions[3]).map((className, index) => {
          const viewMore = avatars.length > MAX_IMAGES && index === 0;
          const avatar = avatars[index] || {};
          const { url, disabled } = avatar;
          const salonBadge = viewMore ? undefined : getSalonBadge(avatar);

          return (
            <React.Fragment key={index}>
              <div className={`${className}`}>
                <div className="relative [container-type:inline-size]">
                  <img
                    src={viewMore || !url ? NoAvatar : url}
                    alt=""
                    className={`rounded-full aspect-square object-cover object-top ${border} ${
                      disabled ? 'opacity-50' : ''
                    }`}
                    onError={(e) => (e.currentTarget.src = NoAvatar)}
                  />
                  {salonBadge && (
                    <div
                      className="pointer-events-none flex items-center justify-center py-1 absolute -bottom-0.5 left-1/2 -translate-x-1/2 rounded-full shadow bg-gradient-to-r from-[#9B6A10] to-[#D6AA44] px-[min(0.75rem,8cqw)] max-w-full text-white"
                      title={SALON_BADGE_LABEL}
                      aria-label={SALON_BADGE_LABEL}
                    >
                      <span className="whitespace-nowrap text-start text-[clamp(6px,12cqw,10px)] font-bold leading-none">
                        {SALON_BADGE_LABEL}
                      </span>
                    </div>
                  )}
                </div>
                {viewMore && (
                  <div className="absolute inset-0 rounded-full bg-black/10">
                    <h1 className="text-sm text-white absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
                      +{avatars.length - MAX_IMAGES + 1}
                    </h1>
                  </div>
                )}
              </div>
              {isPinned && (
                <div className="absolute bottom-0 right-0 w-[30%] aspect-square bg-blue-500 rounded-full flex items-center justify-center">
                  <Icon icon={'pinSmall'} color="white" />
                </div>
              )}
            </React.Fragment>
          );
        })}
    </div>
  );
}

export default AvatarChatGroup;
